import { render, staticRenderFns } from "./AddNutritionListForm.vue?vue&type=template&id=6942d5d4&scoped=true"
import script from "./AddNutritionListForm.vue?vue&type=script&lang=js"
export * from "./AddNutritionListForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6942d5d4",
  null
  
)

export default component.exports